import React, { Fragment, useEffect, useRef, useState } from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import moment from 'moment';
import { SEARCH_PARAMS_SESSION_PAGE } from '@bld/bld-libs/constants';
import { initSearchParamsSession } from '@bld/bld-libs/utils';

import { Box, Stack } from '@mui/material';
import { ConferencePageHeader } from '../components/PageHeader';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { Confirmation } from '../components/modals/common';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import {
  KyReportSearchForm,
  KyReportSearchFormDetail,
  LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS,
} from '../components/searchmenus/ListKyReportSearch';
import KyWorkFinishReportService from '../services/KyWorkFinishReports';
import { FieldTreeService } from '../services/FieldTrees';
import sessionStorageService from '../services/utilities/SessionStorageService';
import { messageUtility } from '../utilities/messageUtility';
import { fetchFieldServiceInfo } from '../utilities/dateSelectorUtility';
import {
  HEADER_CONSTANTS,
  DATE_TIME_FORMAT,
  REQUEST_PARAMS,
  PRIVATE_PARTNER_COMPANY_LABEL,
  WORKER_TYPES,
  KY_STATUS_CONFIG,
  STATUS_CODE,
  API_FLAG,
} from '../utilities/constants';
import EventManager, { EventType } from '../utilities/EventManager.js';
import Tippy from '../components/ReactTippy';
import KyReportUtility from '../utilities/kyReportUtil';
import _dialogLoader from '../utilities/dialogLoader';
import { hasRejectApprovalConflict, isPermissionError } from '../utilities/apiErrorMessage';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';
import { truncateTextNameConcatSuffix } from '../utilities/commonUtil';

const WORK_FINISH_REPORT_STATUS = {
  CONFIRMING: { ID: 0, NAME: '未確認' },
  APPROVAL: { ID: 1, NAME: '確認済' },
};

const defaultSearchParams = {
  work_date: null,
  work_hour_zone: null,
  field_trees: [],
  manager_users: [],
  status: LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID,
};

export class FieldListWorkFinishReport extends React.Component {
  constructor(props) {
    super(props);
    let params = _.cloneDeep(defaultSearchParams);
    this.SessionSearch = initSearchParamsSession(
      SEARCH_PARAMS_SESSION_PAGE.KY_WORK_FINISH_REPORT
    );
    const savedParams = this.SessionSearch.get();
    if (!_.isEmpty(savedParams)) {
      params = { ...params, ...savedParams };
    }

    this.state = {
      isDetailView: false,
      listWorkFinishReports: [],
      isLoading: false,
      fieldId: sessionStorageService.getFieldId(),
      params, // 検索条件
      tempParams: _.cloneDeep(params), // 検索条件(保管用)
      tempParamsModal: _.cloneDeep(params),
      total: 0,
      isDetailSearchFormOpen: false,
      timeZoneInfo: {},
      allLoaded: false,
      isCheckedAll: false,
      listReportSelected: [],
      listFieldTree: [],
      isShowConfirmMultiApprove: false,
      keyRerenderSearchDetail: 0,

      kyReportInfo: {},
      isShowConfirmApprove: false,
    };
    this.events = {
      searchForm: {
        showDetail: this.handleOpenSearchFormDetail,
        closeDetail: this.handleCloseSearchFormDetail,
        clearParamsSearch: this.clearParamsSearch,
        clearTempParamsModal: this.clearTempParamsModal,
        searchExecution: this.searchExecution,
        searchExecutionDetail: this.searchExecutionDetail,
        changeParamData: this.handleChangeParamData,
      },
      table: {
        fetchData: this.handleFetchListKyWorkFinishReports,
        checkOrUncheckRow: this.handleCheckOrUncheckRow,
        checkOrUncheckAll: this.handleCheckOrUncheckAll,
        showDetail: this.handleShowDetail,
        confirmMultiApprove: this.handleShowConfirmMultiApprove,
      },
      detail: {
        navigate: this.handleNavigate,
        confirmApprove: this.handleShowConfirmApprove,
      },
    };
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.isSubmittingFlag = false;
    this.isNavigatingFlag = false;
    this.clearFlag = false;
    this.needReloadData = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.clearFlag === true) {
      this.clearFlag = false;
    }
    if (
      prevState.kyReportInfo !== this.state.kyReportInfo ||
      prevState.isDetailView !== this.state.isDetailView
    ) {
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    }
  }

  handleShowDetail = async id => {
    const { fieldId } = this.state;
    const response = await KyWorkFinishReportService.detail(fieldId, id);
    if (response.result) {
      this.setState({
        isDetailView: true,
        kyReportInfo: response.data.entities,
        listReportSelected: [],
        isCheckedAll: false,
      });
    }
  };

  handleShowConfirmMultiApprove = () => {
    this.setState({
      isShowConfirmMultiApprove: true,
    });
  };

  handleCloseConfirmMultiApprove = () => {
    this.setState({
      isShowConfirmMultiApprove: false,
    });
  };

  handleGetAllDataTable = async () => {
    this.needReloadData = false;
    const { fieldId, params, total } = this.state;
    const response = await KyWorkFinishReportService.list(fieldId, {
      ..._.omit(params, ['field_trees', 'manager_users']),
      field_tree_id_1s: _.map(params.field_trees, 'id'),
      manager_user_ids: _.map(params.manager_users, 'user_id'),
      offset: 0,
      limit: total,
    });
    if (response.result) {
      const resData = response.data.entities.ky_work_finish_reports;
      this.setState({
        allLoaded: true,
        listWorkFinishReports: resData,
        total: response.data.total,
      });
      return resData;
    } else {
      this.handleError(response);
    }
    return [];
  };

  handleNavigate = async isNext => {
    if (this.isNavigatingFlag) return;
    this.isNavigatingFlag = true;
    const { listWorkFinishReports, kyReportInfo } = this.state;
    KyReportUtility.handleNavigate(
      listWorkFinishReports,
      kyReportInfo.ky_work_finish_report.id,
      this.handleShowDetail,
      this.handleCloseDetail,
      this.handleGetAllDataTable,
      isNext
    ).then(() => {
      this.isNavigatingFlag = false;
    });
  };

  handleMultiConfirm = id => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const { fieldId, listReportSelected } = this.state;
    KyWorkFinishReportService.bulkUpdateStatus(fieldId, {
      ids: id ? [id] : listReportSelected,
      consistency_check_flag: id ? API_FLAG.On : API_FLAG.Off,
    })
      .then(res => {
        if (res.result) {
          if (id) {
            this.needReloadData = true;
            this.handleShowDetail(id);
          } else {
            this.handleFetchListKyWorkFinishReports();
          }
        } else {
          this.handleError(res);
        }
      })
      .finally(() => {
        this.isSubmittingFlag = false;
        this.handleCloseConfirmMultiApprove();
        this.handleCloseConfirmApprove();
      });
  };

  handleConfirmWorkFinishReport = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const workFinishReportId = _.get(
      this.state.kyReportInfo,
      'ky_work_finish_report.id'
    );
    const newResponse = await KyWorkFinishReportService.detail(
      this.state.fieldId,
      workFinishReportId
    );
    const kyReportStatus = _.get(newResponse, 'data.entities.ky_report.status');
    this.isSubmittingFlag = false;
    if (kyReportStatus === KY_STATUS_CONFIG.NOT_SUBMIT) {
      this.handleCloseConfirmApprove();
      _dialogLoader.show(CancelAndConfirmDialog, {
        title: messageUtility.getMessage('W-001-308'),
        message: messageUtility.getMessage('W-001-309'),
        confirmButtonText: messageUtility.getMessage('E-000-005-01'),
        cancelButtonText: messageUtility.getMessage('I-000-008'),
        onCancel: () => _dialogLoader.close(),
        onConfirm: () => {
          _dialogLoader.close();
          this.handleMultiConfirm(workFinishReportId);
        },
      });
    } else {
      this.handleMultiConfirm(workFinishReportId);
    }
  };

  handleCloseDetail = () => {
    this.setState({ isDetailView: false });
    if (this.needReloadData) {
      this.handleFetchListKyWorkFinishReports();
      this.needReloadData = false;
    }
  };

  handleFetchListKyWorkFinishReports = notify => {
    if (notify && this.state.allLoaded) {
      notify();
      return true;
    }
    this.setState({ isLoading: true });
    const {
      fieldId,
      params,
      listWorkFinishReports,
      total,
      listReportSelected,
      isCheckedAll,
    } = this.state;
    this.SessionSearch.set(params);
    KyWorkFinishReportService.list(fieldId, {
      ..._.omit(params, ['field_trees', 'manager_users']),
      field_tree_id_1s: _.map(params.field_trees, 'id'),
      manager_user_ids: _.map(params.manager_users, 'user_id'),
      offset: notify ? _.size(listWorkFinishReports) : 0,
      limit: REQUEST_PARAMS.parentLimit,
    })
      .then(res => {
        if (res.result) {
          const resData = res.data.entities.ky_work_finish_reports;
          if (_.isEmpty(resData)) {
            this.setState({
              allLoaded: true,
              listWorkFinishReports: notify ? listWorkFinishReports : [],
              total: notify ? total : 0,
              listReportSelected: notify ? listReportSelected : [],
              isCheckedAll: notify ? isCheckedAll : false,
            });
          } else {
            const newData = _.concat(
              notify ? listWorkFinishReports : [],
              resData
            );
            this.setState({
              listWorkFinishReports: newData,
              total: res.data.total,
              allLoaded: false,
              listReportSelected: notify ? listReportSelected : [],
              isCheckedAll: false,
            });
          }
        } else {
          this.handleError(res);
        }
      })
      .finally(() => {
        if (notify) {
          notify();
        }
        this.setState({ isLoading: false });
        if (this.searchButtonRef.current) {
          this.searchButtonRef.current.disabled = false;
        }
      });
  };

  handleFetchTimeZoneInfo = async () => {
    const timeZoneInfo = await fetchFieldServiceInfo(
      this.state.fieldId,
      sessionStorageService.getWorkHourZone()
    );
    this.setState({ timeZoneInfo });
  };

  handleFetchListFieldTrees = async () => {
    const response = await FieldTreeService.levelList(this.state.fieldId);
    const listFieldTree = _.get(response, 'data.entities.field_trees', []);
    _.forEach(listFieldTree, fieldTree => {
      if (fieldTree.private_partner_company_flag) {
        fieldTree.company_name = fieldTree.company_name.concat(
          PRIVATE_PARTNER_COMPANY_LABEL
        );
      }
    });
    this.setState({
      listFieldTree: _.get(response, 'data.entities.field_trees', []),
    });
  };

  componentDidMount() {
    if (isPrimaryCompanyRoleId()) {
      EventManager.trigger(EventType.ACCESS_KY_REPORT_WORK_PAGE);
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      this.handleFetchListKyWorkFinishReports();
      this.handleFetchTimeZoneInfo();
      this.handleFetchListFieldTrees();
    } else {
      window.location.replace('/error-permission');
    }
  }

  componentWillUnmount() {
    EventManager.trigger(EventType.ACCESS_KY_REPORT_WORK_PAGE);
  }

  handleOpenSearchFormDetail = () => {
    const tempParamsModal = _.cloneDeep(this.state.tempParams);
    this.setState({ isDetailSearchFormOpen: true, tempParamsModal });
  };

  handleCloseSearchFormDetail = () => {
    this.setState({ isDetailSearchFormOpen: false });
  };

  clearParamsSearch = () => {
    this.clearFlag = true;
    this.setState(
      {
        params: _.cloneDeep(defaultSearchParams),
        tempParams: _.cloneDeep(defaultSearchParams),
        tempParamsModal: _.cloneDeep(defaultSearchParams),
        listWorkFinishReports: [],
      },
      () => {
        this.handleFetchListKyWorkFinishReports();
      }
    );
  };

  clearTempParamsModal = () => {
    this.setState(prev => ({
      tempParamsModal: _.cloneDeep(defaultSearchParams),
      keyRerenderSearchDetail: prev.keyRerenderSearchDetail + 1,
    }));
  };

  searchExecution = () => {
    const params = _.cloneDeep(this.state.tempParams);
    this.setState(
      { params, isDetailSearchFormOpen: false, listWorkFinishReports: [] },
      () => {
        this.handleFetchListKyWorkFinishReports();
      }
    );
  };

  searchExecutionDetail = () => {
    this.searchButtonRef.current.disabled = true;
    const tempParams = _.cloneDeep(this.state.tempParamsModal);
    const currentParams = this.state.params;
    const params = _.cloneDeep({ ...currentParams, ...tempParams });

    this.setState(
      {
        params,
        tempParams,
        isDetailSearchFormOpen: false,
        listWorkFinishReports: [],
      },
      () => {
        this.handleFetchListKyWorkFinishReports();
      }
    );
  };

  handleChangeParamData = (name, values, stateName) => {
    const newParams = _.cloneDeep(this.state[stateName]);
    newParams[name] = values;
    this.setState({ [stateName]: newParams });
  };

  handleCheckOrUncheckRow = (e, id) => {
    e.stopPropagation();
    const { checked } = e.target;
    const { listReportSelected, listWorkFinishReports } = this.state;
    const newListReportSelected = checked
      ? [...listReportSelected, id]
      : _.filter(listReportSelected, selectedId => selectedId !== id);
    this.setState({
      listReportSelected: newListReportSelected,
      isCheckedAll:
        _.size(newListReportSelected) === _.size(listWorkFinishReports),
    });
  };

  handleCheckOrUncheckAll = e => {
    const { checked } = e.target;
    const listReportSelected = checked
      ? _.map(this.state.listWorkFinishReports, 'id')
      : [];
    this.setState({ listReportSelected, isCheckedAll: checked });
  };

  handleShowConfirmApprove = () => {
    this.setState({
      isShowConfirmApprove: true,
    });
  };

  handleCloseConfirmApprove = () => {
    this.setState({
      isShowConfirmApprove: false,
    });
  };

  handleError = response => {
    const message = _.get(response, 'data.message');
    if (isPermissionError(message)) {
      _dialogLoader.show(FormInformationDialog, {
        title: messageUtility.getMessage('E-001-464'),
        message: messageUtility.getMessage('E-001-465'),
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseErrorPermissionDialog,
      });
    } else if (hasRejectApprovalConflict(message)) {
      _dialogLoader.show(CancelAndConfirmDialog, {
        title: messageUtility.getMessage('E-001-402'),
        message: messageUtility.getMessage('E-001-470'),
        confirmButtonText: messageUtility.getMessage('I-000-180'),
        cancelButtonText: messageUtility.getMessage('I-000-017'),
        onCancel: () => {
          this.needReloadData = true;
          _dialogLoader.close();
        },
        onConfirm: this.handleConfirmApprovalConflict,
      });
    } else if (_.get(response, 'status') === STATUS_CODE.forbidden) {
      window.location.replace('/error-permission');
    }
  };

  handleCloseErrorPermissionDialog = () => {
    _dialogLoader.close();
    window.location.replace('/error-permission');
    this.setState({
      allLoaded: true,
      listWorkFinishReports: [],
      total: 0,
      listReportSelected: [],
      isCheckedAll: false,
    });
  };

  handleConfirmApprovalConflict = () => {
    this.needReloadData = true;
    this.handleShowDetail(
      _.get(this.state.kyReportInfo, 'ky_work_finish_report.id')
    );
    _dialogLoader.close();
  };

  getPageTitle = () => {
    const { isDetailView, kyReportInfo } = this.state;
    if (isDetailView) {
      const { foreman_user_name, company_name } = kyReportInfo.ky_report;
      return (
        <Box sx={{ display: 'flex', minHeight: '30px', alignItems: 'center' }}>
          <i
            className='i-close__header i-2_4x work-finish-report-detail__icon-close'
            onClick={this.handleCloseDetail}
          />
          <div className='work-finish-report-detail__title'>
            作業終了報告者
            <span className='work-finish-report-detail__description header-description'>
              {foreman_user_name}（{company_name}）
            </span>
          </div>
        </Box>
      );
    }
    return '作業終了報告';
  };

  render() {
    return (
      <div className='main'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 作業終了報告一覧</title>
        </Helmet>
        <ConferencePageHeader title={this.getPageTitle()} />
        <div
          className={`main__body ${
            this.state.isDetailView ? '' : 'work-finish-report'
          }`}
        >
          {this.state.isDetailView ? (
            <WorkReportDetail
              kyReportInfo={this.state.kyReportInfo}
              callbacks={this.events.detail}
              disabledNavigation={this.state.total <= 1}
            />
          ) : (
            <WorkReportList
              state={this.state}
              tableCallBacks={this.events.table}
              searchFormCallbacks={this.events.searchForm}
              searchButtonRef={this.searchButtonRef}
              clearFlag={this.clearFlag}
            />
          )}
        </div>
        <Confirmation
          visible={this.state.isDetailSearchFormOpen}
          title={messageUtility.getMessage('I-000-268')}
          message={
            <KyReportSearchFormDetail
              key={this.state.keyRerenderSearchDetail}
              state={this.state}
              callbacks={this.events.searchForm}
            />
          }
          confirmButtonText={messageUtility.getMessage('I-000-164-09')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onConfirm={this.searchExecutionDetail}
          onCancel={this.handleCloseSearchFormDetail}
          effectiveButtonClassName='btn--stay'
          rootClassName='search-form-detail-dialog'
        />
        <Confirmation
          visible={this.state.isShowConfirmMultiApprove}
          title='一括確認'
          message='こちらの内容で一括確認をしてもよろしいでしょうか。'
          confirmButtonText={messageUtility.getMessage('E-000-005-01')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onConfirm={() => this.handleMultiConfirm()}
          onCancel={this.handleCloseConfirmMultiApprove}
          effectiveButtonClassName='btn--effective--filled'
        />
        <Confirmation
          visible={this.state.isShowConfirmApprove}
          title='報告内容の確認'
          message='こちらの内容で作業終了報告を受領します。よろしいでしょうか。'
          confirmButtonText={messageUtility.getMessage('E-000-005-01')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onConfirm={this.handleConfirmWorkFinishReport}
          onCancel={this.handleCloseConfirmApprove}
          effectiveButtonClassName='btn--effective--filled'
        />
      </div>
    );
  }
}

const WorkReportList = ({
  state,
  tableCallBacks,
  searchFormCallbacks,
  searchButtonRef,
  clearFlag,
}) => (
  <Fragment>
    <KyReportSearchForm
      searchButtonRef={searchButtonRef}
      state={state}
      callbacks={searchFormCallbacks}
      clearFlag={clearFlag}
    />
    <Box sx={{ height: '52px', padding: '12px 16px' }}>
      <button
        className={`work-finish-report__button-confirm btn--effective--filled ${
          _.isEmpty(state.listReportSelected) ? 'btn--disabled' : ''
        }`}
        onClick={tableCallBacks.confirmMultiApprove}
      >
        一括確認
      </button>
    </Box>
    <WorkReportTable
      state={state}
      tableCallBacks={tableCallBacks}
    />
  </Fragment>
);

const WorkReportDetail = ({ kyReportInfo, callbacks, disabledNavigation }) => (
  <Fragment>
    <WorkReportDetailBody kyReportInfo={kyReportInfo} />
    <WorkReportDetailFooter
      dataInfo={kyReportInfo.ky_work_finish_report}
      callbacks={callbacks}
      disabledNavigation={disabledNavigation}
    />
  </Fragment>
);

const splitConfirmItems = rawItems => {
  const items = _.chain(_.range(1, 11))
    .map(i => {
      const title = _.get(rawItems, `confirm_item_${i}_title`);
      const value = _.get(rawItems, `confirm_item_${i}_value`);
      return title ? { label: title, value } : null;
    })
    .compact()
    .value();

  return [_.slice(items, 0, 5), _.slice(items, 5, 10)];
};

const ConfirmationItem = ({ label, value }) => (
  <Stack spacing={1} direction='row'>
    <Box className='work-finish-report-detail__title'>
      {label}
      <span className='work-finish-report-detail__description'>
        &nbsp;{value}
      </span>
    </Box>
  </Stack>
);

const ReportConfirm = ({ data }) => {
  const [leftItems, rightItems] = splitConfirmItems(data);

  return (
    <Stack direction='row' spacing={2.5}>
      <Box sx={{ width: '50%' }}>
        <Stack spacing={1}>
          {_.map(leftItems, (confirmItem, index) => (
            <ConfirmationItem
              key={index}
              label={confirmItem.label}
              value={confirmItem.value}
            />
          ))}
        </Stack>
      </Box>
      <Box sx={{ width: '50%' }}>
        <Stack spacing={1}>
          {_.map(rightItems, (confirmItem, index) => (
            <ConfirmationItem
              key={index}
              label={confirmItem.label}
              value={confirmItem.value}
            />
          ))}
        </Stack>
      </Box>
    </Stack>
  );
};

const WorkReportDetailBody = ({ kyReportInfo }) => {
  const renderWorkDetails = (data, index, notShowIndex) => (
    <Fragment key={index}>
      <div className='work-finish-report-detail__label'>
        作業内容{notShowIndex ? '' : ` ${index + 1}`}：{data.work_content}
      </div>
      {data.work_schedule_id && (
        <div className='work-finish-report-detail__box-wrapper'>
          <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='baseline'
            spacing={1}
          >
            <Stack sx={{ width: '40%' }} spacing='8px'>
              {_.map(
                [
                  { title: '会社名', description: data.company_name },
                  { title: '作業場所', description: data.work_place },
                  ...(data.safety_instruction !== null
                    ? [
                        {
                          title: '安全指示事項',
                          description: data.safety_instruction,
                        },
                      ]
                    : []),
                ],
                (item, idx) => (
                  <Stack
                    key={idx}
                    direction='row'
                    alignItems='start'
                    spacing='8px'
                  >
                    <Box
                      sx={{ minWidth: '84px' }}
                      className='work-finish-report-detail__title'
                    >
                      {item.title}
                    </Box>
                    <Box
                      sx={{ flex: 1 }}
                      className='work-finish-report-detail__description'
                    >
                      {item.description}
                    </Box>
                  </Stack>
                )
              )}
            </Stack>
            <Stack
              direction='row'
              sx={{ width: '40%' }}
              alignItems='start'
              justifyContent='space-between'
              spacing='8px'
            >
              <Box
                sx={{ minWidth: '84px' }}
                className='work-finish-report-detail__title'
              >
                職種/職長
              </Box>
              <Box
                sx={{ flex: 1 }}
                className='work-finish-report-detail__description'
              >
                {data.work_job}/{data.foreman_user_name}
              </Box>
            </Stack>
            <Box
              className='detail-ky__text-wrapper'
              sx={{
                width: '20%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
              }}
            >
              <Stack
                direction='row'
                alignItems='center'
                justifyContent='space-between'
                spacing='8px'
              >
                <Box
                  sx={{ width: '24%', minWidth: 'fit-content' }}
                  className='work-finish-report-detail__title'
                >
                  予定人工
                </Box>
                <Box
                  sx={{ width: '76%' }}
                  className='work-finish-report-detail__description'
                >
                  {data.dayworker_type === WORKER_TYPES.contractor.id
                    ? WORKER_TYPES.contractor.name
                    : WORKER_TYPES.regular.name}{' '}
                  {data.calcd_sum_man_hours}
                </Box>
              </Stack>
            </Box>
          </Stack>
        </div>
      )}
    </Fragment>
  );
  const workFinishReportConfig = _.omit(kyReportInfo.ky_work_finish_report, [
    'id',
    'status',
    'contact_note',
  ]);
  return (
    <Box className='work-finish-report-detail' sx={{ padding: '12px 16px' }}>
      {_.map(kyReportInfo.works, (data, index) =>
        renderWorkDetails(data, index, _.size(kyReportInfo.works) === 1)
      )}
      {isShowConfigItem(workFinishReportConfig) && (
        <div className='work-finish-report-detail__box-wrapper report-box'>
          <div className='work-finish-report-detail__label'>作業終了報告</div>
          <div className='report-info-box'>
            <ReportConfirm data={workFinishReportConfig} />
          </div>
        </div>
      )}
      <div className='work-finish-report-detail__box-wrapper report-box'>
        <div className='work-finish-report-detail__label'>連絡事項</div>
        <div className='report-info-box'>
          <div className='work-finish-report-detail__title'>
            {kyReportInfo.ky_work_finish_report.contact_note}
          </div>
        </div>
      </div>
    </Box>
  );
};

const isDisable = status => status === WORK_FINISH_REPORT_STATUS.APPROVAL.ID;

const WorkReportDetailFooter = ({
  dataInfo,
  callbacks,
  disabledNavigation,
}) => {
  const { navigate, confirmApprove } = callbacks;
  const { status } = dataInfo;
  return (
    <div className='work-finish-report-detail__footer'>
      <Box textAlign='center' sx={{ marginBottom: '12px' }}>
        <button
          onClick={!isDisable(status) && confirmApprove}
          className={`work-finish-report__button-confirm btn--effective--filled ${
            isDisable(status) ? 'btn--disabled' : ''
          }`}
        >
          確認
        </button>
      </Box>
      <Stack
        direction='row'
        justifyContent='space-between'
        px='12px'
        sx={{ paddingTop: '12px', borderTop: '1px solid #BDBDBD' }}
      >
        <NavigationLink
          iconClass={`i-2x i-arrow-left--black ${disabledNavigation &&
            'disabled'}
          `}
          text='前の作業終了報告を確認'
          reverse={false}
          disabled={disabledNavigation}
          onClick={() => navigate(false)}
        />
        <NavigationLink
          iconClass={`i-2x i-arrow-right--black ${disabledNavigation &&
            'disabled'}
          `}
          text='次の作業終了報告を確認'
          reverse={true}
          disabled={disabledNavigation}
          onClick={() => navigate(true)}
        />
      </Stack>
    </div>
  );
};

const NavigationLink = ({ iconClass, text, reverse, disabled, onClick }) => (
  <Stack
    direction='row'
    spacing='4px'
    alignItems='center'
    onClick={disabled ? () => {} : onClick}
    sx={{ fontSize: '14px', cursor: disabled ? 'default' : 'pointer' }}
  >
    {!reverse && <i className={iconClass} aria-hidden='true' />}
    <a className={`clickable-text has-icon-2x ${disabled ? 'disabled' : ''}`}>
      {text}
    </a>
    {reverse && <i className={iconClass} aria-hidden='true' />}
  </Stack>
);

const WorkReportTable = ({ state, tableCallBacks }) => {
  const {
    total,
    isLoading,
    listWorkFinishReports,
    listReportSelected,
    isCheckedAll,
  } = state;
  const {
    fetchData,
    checkOrUncheckRow,
    checkOrUncheckAll,
    showDetail,
  } = tableCallBacks;

  return (
    <Fragment>
      <div
        className='work-finish-report__table'
        id='scroll-parent-list-work-finish-report'
      >
        <table className='table'>
          <thead>
            {renderWorkReportTableHeader(checkOrUncheckAll, isCheckedAll)}
          </thead>
          <tbody>
            {_.map(listWorkFinishReports, (data, index) =>
              renderWorkReportTableRow(
                data,
                index,
                listReportSelected,
                checkOrUncheckRow,
                showDetail
              )
            )}
          </tbody>
        </table>
        <InfinityScrollLoad
          targetId='scroll-parent-list-work-finish-report'
          total={total}
          isLoading={isLoading}
          callback={notifyEnd => fetchData(notifyEnd)}
          no_data_message={messageUtility.getMessage('I-000-005')}
        />
      </div>
    </Fragment>
  );
};

const isChecked = (id, listReportSelected) =>
  _.includes(listReportSelected, id);

const renderWorkReportTableHeader = (checkOrUncheckAll, isCheckedAll) => {
  const headers = [
    { label: '', isCheckbox: true },
    { label: '日付' },
    { label: 'ステータス' },
    { label: '一次協力会社' },
    { label: '職種/作業内容' },
    { label: '元請担当者' },
    { label: '元請確認者' },
  ];

  return (
    <tr className='table__label'>
      {_.map(headers, (header, index) => (
        <td
          key={index}
          className={`value-table ${
            header.isCheckbox ? '' : 'value-table--table__label'
          }`}
        >
          {header.isCheckbox ? (
            <div className='btn-checkbox'>
              <label>
                <input
                  type='checkbox'
                  checked={isCheckedAll}
                  onClick={e => checkOrUncheckAll(e)}
                />
                <i className='i-square-checkbox i-2_4x' />
              </label>
            </div>
          ) : (
            <div className='value-table__label'>{header.label}</div>
          )}
        </td>
      ))}
    </tr>
  );
};

const getStatusLabel = status => {
  return status === WORK_FINISH_REPORT_STATUS.CONFIRMING.ID ? (
    <div className='status-label status--confirming'>
      {WORK_FINISH_REPORT_STATUS.CONFIRMING.NAME}
    </div>
  ) : (
    <div className='status-label status--approval'>
      {WORK_FINISH_REPORT_STATUS.APPROVAL.NAME}
    </div>
  );
};

const getLabelFirstName = listNames => {
  const filteredListNames = _.uniq(listNames);
  if (_.isEmpty(filteredListNames)) {
    return 'ー';
  } else if (_.size(filteredListNames) === 1) {
    return filteredListNames[0];
  } else
    return (
      <Fragment>
        <span className='row-table--item name-label'>
          {filteredListNames[0]}
        </span>
        <span className='multi-name-label'>、ほか</span>
      </Fragment>
    );
};

const renderWorkReportTableRow = (
  data,
  index,
  listReportSelected,
  checkOrUncheckRow,
  showDetail
) => {
  const {
    id,
    work_date,
    status,
    company_name_1,
    job_names,
    work_contents,
    manager_user_names,
    review_contractor_user_name,
  } = data;
  const managerUserNames = filterNotEmptyValues(manager_user_names);
  return (
    <tr
      key={index}
      className='row-table table__item'
      onClick={() => showDetail(id)}
    >
      <td className='row-table--item column-checkbox'>
        <div className='btn-checkbox' onClick={e => e.stopPropagation()}>
          <label>
            <input
              type='checkbox'
              checked={isChecked(id, listReportSelected, status)}
              onClick={e => checkOrUncheckRow(e, id)}
            />
            <i className='i-square-checkbox i-2_4x' />
          </label>
        </div>
      </td>
      <td className='row-table--item column-target-date'>
        {moment(work_date).format(DATE_TIME_FORMAT.slashDateFormatNoYear)}
      </td>
      <td className='row-table--item column-status'>
        {getStatusLabel(status)}
      </td>
      <td className='row-table--item column-field-tree-name'>
        <TooltipDisplay
          disable={_.isEmpty(_.toString(company_name_1).trim())}
          html={<div className='data-table__tooltip'>{company_name_1}</div>}
        >
          <span>{_.toString(company_name_1).trim() || 'ー'}</span>
        </TooltipDisplay>
      </td>
      <td className='row-table--item column-job'>
        <JobNameAndWorkContentTableCell
          job_names={job_names}
          work_contents={work_contents}
        />
      </td>
      <td className='row-table--item column-manager-name'>
        <TooltipDisplay
          disable={_.isEmpty(managerUserNames)}
          html={
            <div className='data-table__tooltip'>
              {managerUserNames.join(', ')}
            </div>
          }
        >
          <div
            className={`row-table--item multi-line-ellipsis ${
              _.size(managerUserNames) > 1 ? 'flex' : ''
            }`}
          >
            <TruncatedTextConcatWithSuffix listNames={managerUserNames} />
          </div>
        </TooltipDisplay>
      </td>
      <td className='row-table--item column-contractor-name'>
        <TooltipDisplay
          disable={_.isEmpty(_.toString(review_contractor_user_name).trim())}
          html={
            <div className='data-table__tooltip'>
              {review_contractor_user_name}
            </div>
          }
        >
          <div className='row-table--item multi-line-ellipsis'>
            {_.toString(review_contractor_user_name).trim() || 'ー'}
          </div>
        </TooltipDisplay>
      </td>
    </tr>
  );
};

const TooltipDisplay = props => {
  return (
    <Tippy
      duration={10}
      distance={24}
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      {...props}
    />
  );
};

const JobNameAndWorkContentTableCell = ({ job_names, work_contents }) => {
  const jobNames = filterNotEmptyValues(job_names);
  const workContents = filterNotEmptyValues(work_contents);
  const isEmptyJobNames = _.isEmpty(jobNames);
  const isEmptyWorkContents = _.isEmpty(workContents);
  return (
    <TooltipDisplay
      disable={isEmptyJobNames && isEmptyWorkContents}
      html={
        <div>
          <div className='data-table__tooltip'>{jobNames.join(', ')}</div>
          <div className='data-table__tooltip'>/{workContents.join(', ')}</div>
        </div>
      }
    >
      <Stack direction='column'>
        <div
          className={`row-table--item job-label ${
            _.size(jobNames) > 1 ? 'flex' : ''
          }`}
        >
          {getLabelFirstName(jobNames)}
        </div>
        <div
          className={`row-table--item job-label ${
            _.size(workContents) > 1 ? 'flex' : ''
          }`}
        >
          /{getLabelFirstName(workContents)}
        </div>
      </Stack>
    </TooltipDisplay>
  );
};

const TruncatedTextConcatWithSuffix = ({ listNames }) => {
  const filteredListNames = _.uniq(listNames);
  if (_.isEmpty(filteredListNames)) {
    return 'ー';
  } else if (_.size(filteredListNames) === 1) {
    return filteredListNames[0];
  } else {
    const wrapperRef = useRef(null);
    const nameRef = useRef(null);
    const nameDisplay = filteredListNames[0];
    const [wrapperWidth, setWrapperWidth] = useState(0);
    useEffect(() => {
      const currentWrapper = wrapperRef.current;
      if (!currentWrapper) {
        return;
      }
      const resizeObserver = new window.ResizeObserver(entries => {
        for (let entry of entries) {
          if (entry.target === currentWrapper) {
            setWrapperWidth(entry.contentRect.width);
          }
        }
      });
      resizeObserver.observe(currentWrapper);

      return () => {
        resizeObserver.unobserve(currentWrapper);
        resizeObserver.disconnect();
      };
    }, []);
    useEffect(() => {
      if (wrapperWidth > 0) {
        truncateTextNameConcatSuffix(
          nameDisplay,
          wrapperRef.current,
          nameRef.current
        );
      }
    }, [wrapperWidth, nameDisplay]);

    return (
      <div ref={wrapperRef}>
        <span
          className='row-table--item name-label label-pre-line'
          ref={nameRef}
        >
          {nameDisplay}
        </span>
        <span className='multi-name-label'>、ほか</span>
      </div>
    );
  }
};

const filterNotEmptyValues = values => {
  return _.chain(values)
    .map(value => (_.isString(value) ? value.trim() : ''))
    .filter(value => value !== '')
    .value();
};

const isShowConfigItem = settingInfo =>
  _.some(settingInfo, item => item !== null);



// WEBPACK FOOTER //
// ./src/pages/FieldListWorkFinishReport.jsx